import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Button from './Button';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`;

const ModalContent = styled.div`
  background-color: #0E1F1F;
  border-radius: 16px;
  padding: 32px;
  width: 90%;
  max-width: 500px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: center;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
`;

const WarningIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: rgba(255, 107, 107, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #FF6B6B;
`;

const Title = styled.h2`
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: #FFFFFF;
  margin: 0;
`;

const Description = styled.p`
  font-family: 'Ubuntu', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 8px;
`;

interface SubscriptionErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
}

const SubscriptionErrorModal: React.FC<SubscriptionErrorModalProps> = ({ 
  isOpen, 
  onClose, 
  message = "С Вашей текущей подпиской невозможно редактирование инвентаря! Оплатите подписку что бы совершать действия с инвентарем!" 
}) => {
  const navigate = useNavigate();

  const handleGoToTariffs = () => {
    onClose();
    navigate('/tariffs');
  };

  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <IconContainer>
          <WarningIcon>⚠️</WarningIcon>
        </IconContainer>
        
        <Title>Ограничениe подписки</Title>
        
        <Description>{message}</Description>
        
        <ButtonsContainer>
          <Button onClick={onClose} variant="secondary">
            Понятно
          </Button>
          <Button onClick={handleGoToTariffs} variant="primary">
            Выбрать тариф
          </Button>
        </ButtonsContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default SubscriptionErrorModal; 